// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"8f36db57","186":"c01c047e","344":"b809033c","372":"3bf05cb0","377":"e2686eec","738":"5aba06e1","841":"cd744e4e","856":"f2c0c0fe","858":"6458a0eb"}[chunkId] + ".chunk.js";
};